import { render, staticRenderFns } from "./FormsNew.vue?vue&type=template&id=a03f8880&"
import script from "./FormsNew.vue?vue&type=script&lang=js&"
export * from "./FormsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports